<template>
  <div
    :class="classes"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'MTagList',
  props: {
    layout: {
      type: String,
      default: 'inline',
      validator: (value) => ['inline', 'wrap', 'one-tag-per-line'].includes(value),
    },
    small: {
      type: Boolean,
      default: false,
    },
    xs: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return [
        'm-tag-list',
        `-layout-${this.layout}`,
        this.small ? '-small' : '',
        this.xs ? '-xs' : '',
      ];
    },
  },
};
</script>

<style lang="scss" type="text/scss">
  .m-tag-list {
    display: flex;
    flex-grow: 1;
    min-width: 0;

    .m-tag {
      flex-shrink: 0;
      margin: 0 .6rem .5rem 0;

      .m-tag {
        margin: 0;
      }
    }

    &.-layout-wrap {
      flex-wrap: wrap;

      .m-tag {
        min-width: 0;
        max-width: 100%;
      }
    }

    &.-layout-one-tag-per-line {
      flex-direction: column;
      align-items: flex-start;

      .m-tag {
        min-width: 0;
        max-width: 100%;
      }
    }

    &.-small {
      .m-tag {
        margin: 0 .5rem .4rem 0;
      }
    }

    &.-xs {
      .m-tag {
        margin: 0 .4rem .3rem 0;
      }
    }
  }

</style>
